import { ReactElement, useEffect } from 'react';
import {
  useCurrentFirebaseUserRef,
  User,
  useSignOutMyBrightlink,
} from '@xolv-mybrightlink/mybrightlink';
import { onSnapshot } from 'firebase/firestore';
import { useClearAuth } from '@xolv-mybrightlink/security';

type ChangeUserPermissionAwareProps = {
  children: ReactElement;
};

export const ChangeUserPermissionAware = (
  props: ChangeUserPermissionAwareProps,
) => {
  const { children } = props;
  const clearAuth = useClearAuth();
  const currentUserFirebaseRef = useCurrentFirebaseUserRef();
  const signOutMyBrightlink = useSignOutMyBrightlink();
  useEffect(() => {
    const unsubscribe = onSnapshot(currentUserFirebaseRef, {
      next: async (snapshot) => {
        const data = snapshot.data() as User;
        if (data?.role === 'No Permission') {
          console.debug('Current user is revoked permission. Force to logout');
          await signOutMyBrightlink();
          clearAuth();
        }
      },
    });
    return () => unsubscribe();
  }, [currentUserFirebaseRef, clearAuth, signOutMyBrightlink]);
  return children;
};
